/* eslint-disable camelcase */

export const GRADE = {
  testnet: 'testnet',
  mainnet: 'mainnet',
};

export const SEQUENCER_MANAGEMENT_TYPE = {
  product: 'product',
  self: 'self',
};

export const DECLARED_STACK_KEYS = {
  arbitrum: 'arbitrum',
  optimism: 'optimism',
  polygon: 'polygon',
  agglayer: 'agglayer',
  agglayer_erigon: 'agglayer_erigon',
  neura: 'neura',
  zk: 'zk',
  base: 'base',
  solana: 'solana',
  polkadot: 'polkadot',
};

export const DECLARED_DAL_KEYS = {
  ethereum: 'ethereum',
  arbitrum: 'arbitrum',
  celestia: 'celestia',
  eiganda: 'eiganda',
  avail: 'avail',
  near: 'near',
};

export const DECLARED_NETWORK_ACCESS = {
  private: 'private',
  public: 'public',
};

export const DECLARED_PARACHAIN_TEMPLATE = {
  generic: 'generic',
  evm: 'evm',
};

export const DECLARED_CORETIME_OPTION = {
  none: 'none',
  interlaced: 'interlaced',
  full: 'full',
};

export const DECLARED_TOKEN = {
  custom: 'custom',
  new: 'new',
  ankr: 'ankr',
  usdc: 'usdc',
  eth: 'eth',
  eth_holesky: 'eth_holesky',
  ankreth: 'ankreth',
  sol: 'sol',
  dot: 'dot',
  baseeth: 'baseeth',
  gasless: 'gasless',
  wnd: 'wnd',
  ksm: 'ksm',
  pas: 'pas',
};

export const DECLARED_CHAIN = {
  eth: 'eth',
  eth_holesky: 'eth_holesky',
  holesky: 'holesky',
  sepolia: 'sepolia',
  hoodi: 'hoodi',
  solana: 'solana',
  solana_testnet: 'solana_testnet',
  neura: 'neura',
  polkadot: 'polkadot',
  paseo: 'paseo',
  kusama: 'kusama',
  westend: 'westend',
  arbitrum: 'arbitrum',
  arbitrum_sepolia: 'arbitrum_sepolia',
  base: 'base',
  base_sepolia: 'base_sepolia',
};

export const ROLLUP_STATUS = {
  initializing: 'initializing',
  pending_deposit: 'pending_deposit',
  deploying_nodes: 'deploying_nodes',
  deploying_bridge: 'deploying_bridge',
  unpaid: 'unpaid',
  pending: 'pending',
  deployed: 'deployed',
  failed: 'failed',
  expired: 'expired',
};

export const DEPLOYMENT_TYPE = {
  arbitrum: 'arbitrum',
  optimism: 'optimism',
  solana: 'solana',
  polkadot: 'polkadot',
};

export const PAYMENT_TYPE = {
  stripe: 'stripe',
  loop: 'loop',
  loop_ankr: 'loop_ankr',
};

export const CONNECT_TYPE = {
  telegram: 'telegram',
  slack: 'slack',
};
